import { defineComponent as S, ref as g, onMounted as E, watch as b, onBeforeUnmount as B, createElementBlock as R, openBlock as k } from "vue";
import { useActiveEntities as q, useWorkspace as x } from "@scalar/api-client/store";
import { mutateSecuritySchemeDiff as D } from "@scalar/api-client/views/Request/libs";
import { getServersFromDocument as U } from "@scalar/oas-utils/helpers";
import { emitCustomEvent as C } from "@scalar/workspace-store/events";
import { watchDebounced as f } from "@vueuse/core";
import v from "microdiff";
import { useNavState as y } from "../../hooks/useNavState.js";
import { useApiClient as A } from "./useApiClient.js";
import { useExampleStore as L } from "../../legacy/stores/useExampleStore.js";
const z = /* @__PURE__ */ S({
  __name: "ApiClientModal",
  props: {
    configuration: {},
    dereferencedDocument: {}
  },
  setup(r) {
    const u = g(null), { client: i, init: d } = A(), { selectedExampleKey: p, operationId: l } = L(), a = q(), c = x(), { isIntersectionEnabled: m } = y(), h = () => ({
      name: "on-before-request",
      hooks: {
        onBeforeRequest: r.configuration.onBeforeRequest
      }
    });
    return E(() => {
      u.value && d({
        el: u.value,
        configuration: {
          ...r.configuration,
          // If the onBeforeRequest hook is configured, we add the plugin to the API client.
          plugins: r.configuration.onBeforeRequest ? [h] : []
        },
        store: c
      });
    }), f(
      () => r.dereferencedDocument,
      (e, o) => {
        var s, t;
        if (!e)
          return;
        const n = v(e, o || {});
        n != null && n.length && (a.activeCollection.value && ((s = i.value) == null || s.resetStore()), c.importSpecFile(void 0, "default", {
          dereferencedDocument: e,
          shouldLoad: !1,
          documentUrl: (t = r.configuration) == null ? void 0 : t.url,
          useCollectionSecurity: !0,
          ...r.configuration
        }));
      }
    ), f(
      () => r.configuration,
      (e, o) => {
        if (!o || !a.activeCollection.value)
          return;
        const n = v(o, e);
        if (!n.some(
          (t) => t.path[0] === "url" || t.path[0] === "content" || t.path[1] === "url" || t.path[1] === "content"
        )) {
          if (n.forEach((t) => {
            t.path[0] === "authentication" && D(t, a, c);
          }), e.servers || o.servers) {
            const t = U(
              e.servers ?? r.dereferencedDocument.servers,
              {
                baseServerURL: e.baseServerURL
              }
            );
            C(u.value, "scalar-replace-servers", {
              servers: t,
              options: {
                disableOldStoreUpdate: !0
              }
            });
          }
        }
        m.value = !1, setTimeout(() => {
          m.value = !0;
        }, 1e3);
      },
      { deep: !0, debounce: 300 }
    ), b(p, (e) => {
      i.value && e && l.value && i.value.updateExample(e, l.value);
    }), B(() => {
      var e;
      return (e = i.value) == null ? void 0 : e.app.unmount();
    }), (e, o) => (k(), R("div", {
      ref_key: "el",
      ref: u
    }, null, 512));
  }
});
export {
  z as default
};
